// extracted by mini-css-extract-plugin
module.exports = {"featuredCategoryImgWrapper":"Category_featuredCategoryImgWrapper__85wbY","featuredCategories":"Category_featuredCategories__8m1bM"};